import { useEffect } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { CheckCircleIcon } from "../utils/icons";
import Button from "../components/ui/Button";

export default function CheckoutSuccess() {
  const location = useLocation();
  const navigate = useNavigate();
  const { reference, orderDetails } = location.state || {};

  useEffect(() => {
    if (!reference) {
      navigate("/");
    }
  }, [reference, navigate]);

  if (!reference) return null;

  return (
    <div className="bg-gray-50 pt-24">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5 }}
          className="bg-white rounded-lg shadow-md p-8 text-center"
        >
          <CheckCircleIcon className="h-16 w-16 text-green-500 mx-auto mb-6" />
          <h1 className="text-3xl font-serif font-bold text-primary-900 mb-4">
            Thank You for Your Order!
          </h1>
          <p className="text-lg text-gray-600 mb-8">
            Your payment was successful and your order is being processed.
          </p>

          <div className="bg-primary-50 rounded-lg p-6 mb-8">
            <h2 className="text-xl font-semibold text-primary-900 mb-4">
              Order Details
            </h2>
            <div className="grid grid-cols-2 gap-4 text-left">
              <div className="text-gray-600">Reference:</div>
              <div>{reference}</div>
              <div className="text-gray-600">Name:</div>
              <div>
                {orderDetails.firstName} {orderDetails.lastName}
              </div>
              <div className="text-gray-600">Email:</div>
              <div>{orderDetails.email}</div>
              <div className="text-gray-600">Shipping Address:</div>
              <div>
                {orderDetails.address}
                <br />
                {orderDetails.city}, {orderDetails.state}
              </div>
            </div>
          </div>

          <div className="space-y-4">
            <Link to="/products">
              <Button variant="outline" fullWidth>
                Continue Shopping
              </Button>
            </Link>
          </div>
        </motion.div>
      </div>
    </div>
  );
} 